import { C_AUTHOR } from '@/constant';

export default () => {
  return (
    <div className="copyright">
      Copyright &copy; {C_AUTHOR.TIME} &nbsp;&nbsp;
      <a
        href={C_AUTHOR.PATH}
        target="view_window"
        className="hover:text-gray-300"
      >
        {C_AUTHOR.NAME}
      </a>
    </div>
  );
};
